import { Component, OnInit } from '@angular/core';
import { SelectableLab } from '../carrier/selectable-lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from "../utils/error-handler"

@Component({
  selector: 'app-progress-tracker',
  templateUrl: './progress-tracker.component.html',
  styleUrls: ['./progress-tracker.component.css']
})
export class ProgressTrackerComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  /*variables*/
  multi: any[];
  view: any[] = [1200, 600];
  selectedLab: SelectableLab;

  /* graph options */
  showXAxis = false;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Status Progress';
  showYAxisLabel = true;
  yAxisLabel = 'Containers';

  /** legend colors*/
  colorScheme = {
    domain: ['#8FBC8B', '#0C88C2', '#E57373', '#123456', '#999333', '#3CEEB9', '#FF8C00', '#258083']
  };

  /* Constructor*/
  constructor(private _messagesService: MessagesService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));    
  }

  /**
   * @description on page loading
   */
  ngOnInit() {
    this.getProgressTrackerData();
  }

  /**
   * @description method to get Data for Progress Tracker
   */
  getProgressTrackerData(){
    
  }

}
